import Cookie from 'universal-cookie'
import { tokenKey } from '../client'

const cookie = new Cookie()

export async function attachFile({ file, conversationId, xhrProgressCb }) {
  const formData = new FormData()
  const token = cookie.get(tokenKey)

  formData.append('ConversationId', conversationId)
  formData.append('file', file)

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()

    xhr.upload.addEventListener('progress', xhrProgressCb, false)
    xhr.open('POST', `${process.env.NEXT_PUBLIC_CHAT_DOMAIN}/api/Chat/attachFile`)
    xhr.setRequestHeader('Authorization', `Bearer ${token}`)

    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4 && xhr.status === 200) resolve(JSON.parse(xhr.response))
      if (xhr.readyState === 4 && xhr.status !== 200) reject(xhr.status)
    }
    xhr.onerror = () => reject(xhr.status)

    xhr.send(formData)
  })
}
